import React, { useState } from "react";
import { ReactComponent as VaultSVG } from "../assets/unlocked-vault.svg";

function Process() {
  return (
    <section>
      <div
        className="max-w-6xl mx-auto px-4 sm:px-6 items-center"
        data-aos-id-gen-method-anchor
      >
        <div className="md:py-20 border-t border-gray-800 w-full">
          {/* Section header */}
          <div className="flex flex-col max-w-3xl mx-auto text-center items-center mb-20 w-full">
            <div
              className="flex w-full items-center justify-center mt-20 md:mt-0"
              data-aos="fade-up"
              data-aos-delay="1000"
            >
              <img
                className="w-full"
                src={require(`../images/phone/double-peak.png`).default}
                alt="phone-profile"
              />
            </div>
            <div
              className="text-4xl md:text-6xl font-extrabold text-primary-1 mt-24 mb-0 md:mb-20"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              How It Works
            </div>
          </div>
          {/* Mobile */}
          <div className="md:hidden flex flex-col items-center">
            <div
              className="flex flex-col items-center text-center justify-center w-full mb-10"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              {/* <ValueCreationIcon className="w-36 mb-4 text-primary-1 fill-current" /> */}

              <div className="text-xxl h1 mb-2 text-white">
                Connect within Circles
              </div>
              <p className="text-2xl text-white mb-10">
                Join forces with like-minded changemakers within{" "}
                <span className="italic mr-2 font-semibold">
                  Generos Circles
                </span>
                : modern giving communities that amplify collective impact.
                Together, champion causes you care about and create change
                beyond what any individual could achieve alone.
              </p>
              <p className="text-2xl text-white mb-10">
                <span className="font-barlow font-bold italic text-primary-1 mr-2">
                  {"Community Power: "}
                </span>
                Pool resources, knowledge, and passion to fuel transformation
                that starts with connection.
              </p>
              <img
                className="w-full md:w-3/6 md:px-10 mb-10"
                src={require(`../images/phone/connect.png`).default}
                alt="phone-orgs"
              />
            </div>
            <div
              className="flex flex-col text-center items-center justify-center w-full mb-10"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="text-xxl h1 mb-2 text-white">
                Contribute with Purpose
              </div>
              <p className="text-2xl text-white mb-10">
                Gift digital gems to help unlock others' vaults and spark a
                chain reaction of generosity. Each gem purchase directly funds
                our{" "}
                <span className="italic font-semibold">
                  Redemption Treasury
                </span>
                , which backs every{" "}
                <span className="font-semibold">Gencoin</span> (our primary
                community token) at{" "}
                <span className="font-semibold">$1 US Dollar</span>, creating a
                transparent and stable foundation for our generosity economy.
              </p>
              <p className="text-2xl text-white mb-10">
                <span className="font-barlow font-bold italic text-primary-1 mr-2">
                  {"Ripple Effect: "}
                </span>
                Watch as your single contribution creates a chain reaction
                throughout the community - activating vaults, building our
                Treasury, and strengthening our entire ecosystem.
              </p>
              <img
                className="w-full md:w-3/6 md:px-10 mb-10"
                src={require(`../images/phone/contribute.png`).default}
                alt="phone-orgs"
              />
            </div>
            <div
              className="flex flex-col items-center text-center justify-center w-full mb-10"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="text-xxl h1 mb-2 text-white">
                Generate Real Value
              </div>

              <p className="text-2xl text-white mb-10">
                As you contribute gems to others you earn vaults in return that
                generate <span className="font-semibold mr-2">Gencoin</span>
                when they fill with gems. Each vault cycle produces at least 10
                Gencoin you can contribute to funding goals or convert to cash.
              </p>
              <p className="text-2xl text-white mb-10">
                <span className="font-barlow font-bold italic text-primary-1 mr-2">
                  {"Generosity That Rewards: "}
                </span>
                Experience a sustainable system where your giving creates both
                meaningful impact and tangible rewards.
              </p>
              <img
                className="w-full md:w-3/6 md:px-10 mb-10"
                src={require(`../images/phone/generate.png`).default}
                alt="phone-orgs"
              />
            </div>
          </div>

          {/* Desktop and Tablet */}
          <div className="hidden md:flex flex-col">
            <div
              className="flex mb-36 items-center"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="flex flex-col items-start justify-center pr-6">
                {/* <div className="flex w-full items-center justify-center mb-10">
                    <ValueCreationIcon className="w-36 mb-4 text-primary-1 fill-current" />
                  </div> */}

                <div className="text-xxl h1 mb-2 text-white">
                  Connect within Circles
                </div>
                <p className="text-3xl text-white mb-10">
                  Join forces with like-minded changemakers within{" "}
                  <span className="italic mr-2 font-semibold">
                    Generos Circles
                  </span>
                  : modern giving communities that amplify collective impact.
                  Together, champion causes you care about and create change
                  beyond what any individual could achieve alone.
                </p>
                <p className="text-3xl text-white mb-10">
                  <span className="font-barlow font-bold italic text-primary-1 mr-2">
                    {"Community Power: "}
                  </span>
                  Pool resources, knowledge, and passion to fuel transformation
                  that starts with connection.
                </p>
              </div>

              <img
                className="w-3/6"
                src={require(`../images/phone/connect.png`).default}
                alt="phone-orgs"
              />
            </div>
            <div
              className="flex mb-36 items-center"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <img
                className="w-3/6"
                src={require(`../images/phone/contribute.png`).default}
                alt="phone-orgs"
              />
              {/* <VaultSVG className="mr-6" /> */}

              <div className="flex flex-col items-start justify-center pl-6">
                {/* <div className="flex w-full items-center justify-center mb-10">
                    <GencoinIcon className="w-36 mb-4 text-primary-1 fill-current" />
                  </div> */}
                <div className="text-xxl h1 mb-2 text-white">
                  Contribute with Purpose
                </div>
                <p className="text-3xl text-white mb-10">
                  Gift digital gems to help unlock others' vaults and spark a
                  chain reaction of generosity. Each gem purchase directly funds
                  our{" "}
                  <span className="italic font-semibold">
                    Redemption Treasury
                  </span>
                  , which backs every{" "}
                  <span className="font-semibold">Gencoin</span> (our primary
                  community token) at{" "}
                  <span className="font-semibold">$1 US Dollar</span>, creating
                  a transparent and stable foundation for our generosity
                  economy.
                </p>
                <p className="text-3xl text-white mb-10">
                  <span className="font-barlow font-bold italic text-primary-1 mr-2">
                    {"Ripple Effect: "}
                  </span>
                  Watch as your single contribution creates a chain reaction
                  throughout the community - activating vaults, building our
                  Treasury, and strengthening our entire ecosystem.
                </p>
              </div>
            </div>
            <div
              className="flex mb-10 items-center"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <div className="flex flex-col items-start justify-center pr-6">
                {/* <div className="flex w-full items-center justify-center mb-10">
                    <GrowIcon className="w-36 mb-4 text-primary-1 fill-current" />
                  </div> */}
                <div className="text-xxl h1 mb-2 text-white">
                  Generate Real Value
                </div>{" "}
                <p className="text-3xl text-white mb-10">
                  As you contribute gems to others you earn vaults in return
                  that generate <span className="font-semibold">Gencoin</span>{" "}
                  when they fill with gems. Each vault cycle produces at least
                  10 Gencoin you can contribute to funding goals or convert to
                  cash.
                </p>
                <p className="text-3xl text-white mb-10">
                  <span className="font-barlow font-bold italic text-primary-1 mr-2">
                    {"Generosity That Rewards: "}
                  </span>
                  Experience a sustainable system where your giving creates both
                  meaningful impact and tangible rewards.
                </p>
              </div>

              <img
                className="w-3/6"
                src={require(`../images/phone/generate.png`).default}
                alt="phone-orgs"
              />
            </div>
          </div>

          {/* How It Works */}
          <div className="flex flex-col max-w-3xl mx-auto text-center items-center mt-10 md:mt-24 mb-20">
            <div
              className="text-4xl h4 mb-6 text-white text-center"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              Giving That Generates More Giving...
            </div>
            <div className="flex justify-center w-full" data-aos="fade-up">
              <VaultSVG
                className="w-5/12 mt-10"
                data-aos="fade-up"
                data-aos-delay="600"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <Flow /> */}
    </section>
  );
}

export default Process;
